// ===========================================================================
// Shared — utilidades de formato transversales.
//
// Helpers mínimos usados por los componentes compartidos. Degradan a un guion
// "—" cuando no hay valor (los campos del backend pueden llegar null).
// ===========================================================================

export const EMPTY_PLACEHOLDER = "—";

/** Fecha ISO → "MM/DD/YYYY" (formato local US). "—" si no hay valor. */
export const formatDate = (iso) => {
  if (!iso) return EMPTY_PLACEHOLDER;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return EMPTY_PLACEHOLDER;
  return d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
};

/** Valor seguro: "—" para null/undefined/string vacío. */
export const safe = (value) =>
  value == null || value === "" ? EMPTY_PLACEHOLDER : value;
